/**
 * Pure state→class decision for the "query executing" energy family — the
 * flagship CH-28 placement (T5.11, §6 item 3). Mirrors T3.5's
 * `computeTransactionEnergyState` shape (see `transactionIndicator.ts`): a
 * single source of truth for whether a running-query indicator (spinner,
 * elapsed timer) should carry the shared `--energy` "work in flight" tint.
 *
 * Consumed by QueryStatusBar's execution-time readout, GridStatusInline's
 * awaiting spinner/label, and MessagesPanel's live "Executing query…" row —
 * the three surfaces that carried a hardcoded amber before this task.
 *
 * Energized only once a query has crossed the long-running threshold
 * (`isLongRunning`); neutral before that (still executing, just not slow
 * yet) and after completion. "Neutral after completion" falls out of
 * `useQueryExecution`'s own reset — it flips `isLongRunning` back to `false`
 * the instant `isExecuting` goes false — not from extra logic here.
 */
export type QueryExecutionEnergyState = 'neutral' | 'energy';

export function computeQueryExecutionEnergyState(isLongRunning: boolean): QueryExecutionEnergyState {
  return isLongRunning ? 'energy' : 'neutral';
}
